import React from "react";

import ConfirmationModal from "./ConfirmationModal";
import { getModalConfig } from "./modalHelper";

const config = getModalConfig("analysisRubricRequired");

const AnalysisRubricRequiredModal = ({
  isOpen,
  onClose,
  onConfirm,
  isNewRole = false,
}) => (
  <ConfirmationModal
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    {...config}
    confirmButtonText={isNewRole ? "Got it" : config.confirmButtonText}
    details={
      isNewRole
        ? "Create this role first, then create and save its Evaluation Criteria before enabling automatic interviews."
        : config.details
    }
    confirmButtonVariant="primary"
  />
);

export default AnalysisRubricRequiredModal;
